import { create } from 'zustand';

import { createPortalSlice, type PortalSlice } from '@air/primitive-portal/createPortalSlice';

import {
  createPageOwnedSelectionBarSlice,
  type PageOwnedSelectionBarSlice,
} from '~/components/v2/store/features/workspace/slices/createPageOwnedSelectionBarSlice';

export type WorkspaceSelectionBarState = PortalSlice & PageOwnedSelectionBarSlice;

export const useWorkspaceSelectionBarStore = create<WorkspaceSelectionBarState>()((...args) => ({
  ...createPortalSlice({ portal: null })(...args),
  ...createPageOwnedSelectionBarSlice()(...args),
}));
